import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {IDailyScoreAvg, IWeeklyAvg, WeeklyReport} from '../';
import {
  AirComponentType,
  DeviceType,
  NamizePipe,
  SensorConditionPipe,
  SensorHeaderPipe,
  SensorUnitPipe,
  TemperatureConverterPipe,
  TemperatureUnit
} from '../../../shared';
import {environment} from '../../../../environments/environment';

import * as mt from 'moment-timezone';
import {Observable} from 'rxjs';



@Injectable()
export class ReportService {

  constructor(private httpClient: HttpClient,
              private sensorHeader: SensorHeaderPipe,
              private sensorUnit: SensorUnitPipe,
              private sensorCondition: SensorConditionPipe,
              private namizePipe: NamizePipe,
              private tempConverter: TemperatureConverterPipe) {
  }

  requestReport(orgToken: string, toDate: Date, groupId?: string, floorId?: string): Observable<WeeklyReport> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${orgToken}`,
      'Content-Type': 'application/json'
    });
    const url = `${environment.afbV2Host}org-users/self/weekly-report`;

    // Set query params
    let params = new HttpParams();
    params = params.append('timezone', mt.tz.guess());
    params = params.append('to', toDate.toISOString());
    if (groupId != null) {
      params = params.append('groupId', groupId.toString());
    }
    if (floorId != null) {
      params = params.append('floorId', groupId.toString());
    }

    // Add header and paramemters to requestOptions
    const options = {
      headers,
      params
    };

    return this.httpClient
      .get<WeeklyReport>(url, options);
  }

  getWeeklyAvgList(weeklyReport: WeeklyReport, tempUnit: TemperatureUnit,
                   hasAwair?: boolean, hasMint?: boolean, hasOmni?: boolean): IWeeklyAvg[] {

    const weeklyAvgList: IWeeklyAvg[] = [];

    const compTypeList: string[] = [AirComponentType.Score, AirComponentType.Temperature, AirComponentType.Humidity,
      AirComponentType.CO2, AirComponentType.Chemicals];
    if (hasAwair) {
      compTypeList.push(AirComponentType.Dust)
    }
    if (hasMint || hasOmni) {
      compTypeList.push(AirComponentType.PM25)
    }
    const weeklyAvg = weeklyReport.weeklyCompSensorAvg;

    for (let i = 0; i < compTypeList.length; i++) {
      const key = compTypeList[i];
      const filteredValue: number = weeklyAvg[key] == null ? null :
        (key === AirComponentType.Temperature ? this.tempConverter.transform(weeklyAvg[key], AirComponentType.Temperature, tempUnit) :
          weeklyAvg[key]);

      const compareTwoWeeksValue: number = weeklyReport.compareTwoWeeks[key];
      const percentage: string = compareTwoWeeksValue == null ? 'No Data' :
        compareTwoWeeksValue > 0 ? `+ ${compareTwoWeeksValue} %` :
          compareTwoWeeksValue === 0 ? `${compareTwoWeeksValue} %` :
            `- ${Math.abs(compareTwoWeeksValue)} %`;

      weeklyAvgList.push({
        percentage,
        sensorHeader: this.sensorHeader.transform(key),
        condition: weeklyAvg[key] != null ? this.sensorCondition.transform(weeklyAvg[key], DeviceType.Awair, key) : 'No Data',
        value: filteredValue != null ? filteredValue : null,
        unit: this.sensorUnit.transform(<AirComponentType>key, tempUnit)
      });
    }

    return weeklyAvgList;
  }

  getDailyScoreAvgList(weeklyReport: WeeklyReport, fromDate: Date): IDailyScoreAvg[] {
    const dailyScoreAvgList: IDailyScoreAvg[] = [];

    const weekdayList: string[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const dailyScoreAvg = weeklyReport.dailyScoreAvg;

    for (let i = 0; i < weekdayList.length; i++) {
      const key = weekdayList[i];
      // To auto set date when going over last day of month
      const ctrDate = new Date(fromDate);
      ctrDate.setDate(ctrDate.getDate() + i);

      dailyScoreAvgList.push({
        date: this.namizePipe.transform(key) + ' ' + ctrDate.getDate(),
        condition: dailyScoreAvg[key] != null ? this.sensorCondition.transform(dailyScoreAvg[key], DeviceType.Awair, 'score') : 'No Data',
        value: dailyScoreAvg[key] != null ? dailyScoreAvg[key] : null
      });
    }

    return dailyScoreAvgList;
  }

  getWorstFactor(weeklyReport: WeeklyReport): string {
    // Does not contain score since score doesn't have index
    let worstKey: string;
    let worstValue: number;

    Object.keys(weeklyReport.weeklyCompIndexAvg).map((key: string) => {
      if (worstValue == null) {
        // Init on first
        worstValue = weeklyReport.weeklyCompIndexAvg[key];
        worstKey = key;
      } else if (weeklyReport.weeklyCompIndexAvg[key] > worstValue) {
        // Compare if looped value is smaller than the init
        worstValue = weeklyReport.weeklyCompIndexAvg[key];
        worstKey = key;
      }
    });

    return worstKey;
  }
}
